import { TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';

@Component({
  selector: 'piqet-angular-add-materials',
  templateUrl: './add-materials.component.html',
  styleUrls: ['./add-materials.component.scss'],
})
export class AddMaterialsComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  adminMaterialData: any;
  materialForm!: FormGroup;
  materialAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  organizationList: any;
  materialList: any;
  regionList: any;
  selectOrganization: any;
  regionData: any;
  selectRegion: any;
  setIndicatorData: any;
  indicatorList: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  selectedMaterial: any;
  @Input() customData: any;
  @Output() saveNewMaterialEvent = new EventEmitter<any>();
  materialInfoDataKey: any;
  materialInfoData: any;
  materialname: any;
  materialInfoDataValues: any;
  mId: any;

  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    private administratorService: AdministratorService
  ) {
    this.adminMaterialData =
      this.modal?.modalService?.config?.initialState?.['newAdminMaterialData'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.materialInfoData = this.modal?.modalService?.config?.initialState?.['tooltipData'];
    this.materialInfoDataKey = Object.keys(this.materialInfoData);
    this.materialInfoDataValues = Object.values(this.materialInfoData);
    this.materialname = this.materialInfoData.name;
    this.isDisabledDropDown = this.modalLabel == 'Review material detail' ? true : false;
    this.materialList = this.adminMaterialData.materialItems;
    this.adminMaterialData.materialId;
    this.regionList = this.adminMaterialData.regionItems;

    const placeHolderOrganization = {
      name: 'All organizations',
    };
    const newOrganizationlist = [placeHolderOrganization].concat(
      this.adminMaterialData.organizationList
    );
    this.organizationList = newOrganizationlist;
    this.indicatorList = this.adminMaterialData.indicatiorList;
    this.organizatioListFunction();
    this.getRegionData();
  }

  ngOnInit(): void {
    const form = [];
    for (let i = 0; i < this.indicatorList.length; i++) {
      form[this.indicatorList[i].name] = new FormControl(
        this.adminMaterialData.indicatiorList[i].defaultValue || 0,
        Validators.required
      );
    }
    this.materialForm = new FormGroup(form);
    this.materialAddEditForm = this.formBuilder.group({
      material: [this.adminMaterialData.materialId || null, Validators.required],
      region: [null, Validators.required],
      organizationName: [this.adminMaterialData.organizationId || null],
    });
    this.setFormData();
  }

  toTitleCase(str: any) {
    return str.replace(/\w\S*/g, (txt: any) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  onChange(value: any) {
    this.materialAddEditForm.controls['region'].setValue(null);
    if (!!value?.id) {
      this.mId = value.id;
      this.selectedMaterial = value.description;
      this.administratorService.GetMaterialRegions(value.id).subscribe((data: any) => {
        this.regionData = data.data;
      });
    } else {
      this.regionData = [];
    }
  }
  onChangeRegion(value: any) {
    this.getMaterialInfo(value);
  }

  getMaterialInfo(data: any) {
    this.administratorService.GetMaterialInfo(this.mId, data.id).subscribe((data: any) => {
      this.materialInfoData = data.data;
      this.materialInfoDataKey = Object.keys(data.data);
      this.materialInfoDataValues = Object.values(data.data);
      this.materialname = this.materialInfoData.name;
    });
  }
  async organizatioListFunction() {
    await this.organizationList?.map((item: any) => {
      if (item.id == this.adminMaterialData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }
  async getRegionData() {
    await this.regionList.map((item: any) => {
      if (item.id == this.adminMaterialData.regionId) {
        return (this.selectRegion = item);
      }
    });
  }

  setFormData() {
    this.materialAddEditForm.patchValue({ region: this.selectRegion }),
      this.materialAddEditForm.patchValue({ organizationName: this.selectOrganization });
  }

  onSave() {
    this.submitted = true;
    if (
      this.materialAddEditForm.controls['region'].value?.name == '--Select region-- ' ||
      (this.activatedRoute == 'admin-material' &&
        !this.materialAddEditForm.controls['region'].value?.name)
    ) {
      return;
    }
    if (this.materialAddEditForm.status == 'VALID' && this.materialForm.status == 'VALID') {
      const entires = Object.entries(this.materialForm.value);
      const resultArray: any = [];
      let i = {};
      const entiresArray = this.adminMaterialData.indicatiorList.map((obj: any, index: any) => ({
        ...obj,
        ...entires[index],
      }));
      entiresArray.forEach((event: any, index: any) => {
        i = {
          indicatorId: event.indicatorId,
          name: event.name,
          unit: event.unit,
          defaultValue: event[1],
          equivalencyUnits: event.equivalencyUnits,
          multiplier: event.multiplier,
        };
        resultArray.push(i);
      });
      const materialPayload = {
        materialId: this.materialAddEditForm.controls['material'].value,
        regionId:
          this.materialAddEditForm.controls['region'].value?.id || this.adminMaterialData.regionId,
        organizationId:
          this.materialAddEditForm.controls['organizationName'].value?.name ==
          '--All organization -- '
            ? null
            : this.materialAddEditForm.controls['organizationName'].value?.id,
        indicatiorList: resultArray,
      };
      this.saveNewMaterialEvent.emit(materialPayload);
      this.onClose();
    }
  }

  onClose() {
    this.modal.close();
  }

  commonInputSearch(term: string, item: any) {
    return item.description?.toLowerCase().includes(term.toLowerCase());
  }

  nameInputSearch(term: string, item: any) {
    return item.name?.toLowerCase().includes(term.toLowerCase());
  }
}
